import PageLoader from './Pageloader';
import { _Objects, ScrollSlider, svgInject } from './main';
import { getDateFromString, formatDate, formatZeroNum, formatNumObj } from './helpers';
import { queryChart, queryStructure } from './graphql/queries';
import { RegionMap } from './regionMap';
import { bindCharts, Chart } from './charts';

export class Cards {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$cardSlider = $('.js-scrollslider.cards__slider');
    _this.currentYear = _Objects.Timeline.getValue();
    _this.$cards = null;
    _this.chartData = {};

    _this.indicators = [
      {
        id: 19,
        name: 'volume',
        type: 'TYPE_SUBJECT'
      },
      {
        id: 20,
        name: 'readiness',
        type: 'TYPE_SUBJECT'
      },
      {
        id: 21,
        name: 'extra',
        type: 'TYPE_SUBJECT'
      },
      {
        id: 33,
        name: 'lastready',
        type: 'TYPE_OBJECT'
      },
      {
        id: 302,
        name: 'biggest',
        type: 'TYPE_OBJECT'
      }
    ];
    _this.structureIdx = [];
    _this.subjectsData = [];
    _this.objectsData = [];
    _this.isLoading = false;
  }

  init() {
    let _this = this;

    _Objects.CardSlider = new ScrollSlider(_this.$cardSlider[0]);

    /**
     * on Timeline changed
     */
    _Objects.Timeline.$container.on('changed', function () {
      _this.currentYear = _Objects.Timeline.getValue();
      _this.updateData();
    });

    return _this.updateData();
  }

  updateData() {
    let _this = this;

    _this.setLoading(true);
    return new Promise((resolve, reject) => {
      return _this.getNominData().then(() => {
        _this.setLoading(false);
        resolve();
        return _this.updateCards(_this.filterObjectsData({
          year: _this.currentYear
        }));
      });
    });
  }

  getNominData(queryParams = {}) {
    let _this = this;
    queryParams = Object.assign({
      year: _this.currentYear
    }, queryParams);

    return _this.getNominationsStructure(queryParams).then(() => {
      return _this.getNominationsObjects(queryParams);
    }).then(() => {
    });
  }

  getNominationsStructure(queryParams = {}) {
    let _this = this;
    let queries = [];

    const defaultParams = Object.assign({
      year: _this.currentYear,
      indicator: '',
      value: '1'
    }, queryParams);

    return new Promise((resolve, rej) => {
      let currStructIdx = _this.filterStructData(queryParams);
      if (currStructIdx) resolve();
      else {
        _this.indicators.forEach(({ id, type }) => {
          const indicatorObj = {
            structureType: type,
            indicator: 'Столбец' + id
          };
          const params = Object.assign({}, defaultParams, indicatorObj);
          queries.push(queryStructure(params));
        });
        resolve(Promise.all(queries).then((data) => {
          data.forEach((structData, i) => _this.saveStructure(Object.assign(defaultParams, { nominName: _this.indicators[i].name }), structData));
        }));
      }
    });
  }

  getNominationsObjects(queryParams = {}) {
    let _this = this;
    let queries = [];

    return new Promise((resolve, rej) => {
      let currObjectsData = _this.filterObjectsData(queryParams);
      if (currObjectsData) resolve();
      else {
        let currStructIdx = _this.filterStructData(queryParams);
        if (!currStructIdx || !currStructIdx.length) resolve(null);
        const structIds = currStructIdx.map(({ id }) => id);
        const queryArrParams = Object.assign({
          id: structIds
        }, queryParams);

        resolve(queryChart(queryArrParams).then(({ data }) => {
          currStructIdx.forEach(({ id, nominName, objectMeta }) => {
            const currChart = data.chart.find((chart) => chart.id === id);
            _this.saveObjects(Object.assign(queryParams, { nominName, objectMeta, id }), currChart);
          });
        }));
      }
    });
  }

  saveStructure(queryParams, data) {
    let _this = this;

    let currYearStructObj = _this.structureIdx.filter(({ year }) => year === queryParams.year)[0];
    let id = data.data.structure.length
      ? data.data.structure[0].childList.filter(({ name }) => name === 'Год')[0].id
      : null;

    if (!currYearStructObj) {
      currYearStructObj = {
        year: queryParams.year,
        indicators: []
      };
      _this.structureIdx.push(currYearStructObj);
    }
    if (id !== null) {
      currYearStructObj.indicators.push({
        id: id,
        type: data.data.structure[0].type,
        nominName: queryParams.nominName,
        objectMeta: JSON.parse(data.data.structure[0].meta)
      });
    }
  }

  saveObjects(queryParams, data) {
    let _this = this;

    let currYearObjectsData = _this.objectsData.find(({ year }) => year === queryParams.year);
    const structureId = queryParams.id;
    const structureElement = _this.structureIdx[0].indicators.find(({ id }) => id === structureId);
    const chart = data ? data.axisX[0] : null;

    if (!currYearObjectsData) {
      currYearObjectsData = {
        year: queryParams.year,
        charts: []
      };
      _this.objectsData.push(currYearObjectsData);
    }
    if (chart !== null && structureElement) {
      currYearObjectsData.charts.push({
        chart: chart,
        type: structureElement.type,
        nominName: queryParams.nominName,
        objectMeta: queryParams.objectMeta
      });
    }
  }

  filterStructData(queryParams) {
    let _this = this;

    let currStructObj = _this.structureIdx.filter(({ year }) => year === queryParams.year);
    return currStructObj.length ? currStructObj[0].indicators : null;
  }

  filterObjectsData(queryParams) {
    let _this = this;

    let currObjectsData = _this.objectsData.filter(({ year }) => year === queryParams.year);
    return currObjectsData.length ? currObjectsData[0].charts : null;
  }

  updateCards(objectsData) {
    let _this = this;

    _this.$container.toggleClass('_nodata', !objectsData);

    let cards = $.map(objectsData, (obj) => {
      return new Card(obj);
    });

    let $cards = _this.$cards = $.map(cards, function (card) {
      return card.$el[0];
    });
    _Objects.CardSlider.setSlides($cards);
    if ($cards.length) {
      _this.setChart();
    }
  }

  setChart() {
    const chartId = 'card-chart';
    const $chart = $(`.js-chart[data-chart-id="${chartId}"]`);
    bindCharts($chart);
    const _chart = Chart.get(chartId);
    if (!_chart) {
      Chart.make(chartId).show();
    } else {
      _chart.$chart = $chart;
      _chart.initChartData();
      _chart.show();
    }
  }

  setLoading(isLoading = false) {
    let _this = this;

    _this.isLoading = isLoading;
    _this.$container.toggleClass('_loading', isLoading);
  }
}


let cardTemplate = {
  box: '<div class="card js-card" data-card-id="" data-page-target="build-progress"> <div class="card__label js-card-label"></div> <div class="card__wrapp"> <div class="card__title js-card-title js-textoverflow"> <div class="card__category"> <p class="js-card-title-text"></p> </div> <div class="card__object js-card-object"> <p class="js-card-object-text"></p> </div> </div> <div class="card__objinfo js-card-objinfo"></div> </div></div>',
  labels: {
    object: '<div class="achieve-label _object"> <div class="achieve-label__strip"></div> <div class="achieve-label__badge"> <div class="achieve-label__badge-border"> <img src="img/icons/i-ach-lbl-border.svg" alt="" class="svg-pic"> </div> <div class="achieve-label__icon"> <i><img src="img/icons/awards/i-object.svg" alt="" class="svg-pic"></i> </div> </div></div>',
    build: '<div class="achieve-label _build"> <div class="achieve-label__strip"></div> <div class="achieve-label__badge"> <div class="achieve-label__badge-border"> <img src="img/icons/i-ach-lbl-border.svg" alt="" class="svg-pic"> </div> <div class="achieve-label__icon"> <i><img src="img/icons/awards/i-build.svg" alt="" class="svg-pic"></i> </div> </div> </div>',
    place: '<div class="achieve-label _place"> <div class="achieve-label__strip"></div> <div class="achieve-label__badge"> <div class="achieve-label__badge-border"> <img src="img/icons/i-ach-lbl-border.svg" alt="" class="svg-pic"> </div> <div class="achieve-label__icon"> <i><img src="img/icons/awards/i-place.svg" alt="" class="svg-pic"></i> </div> </div> </div>',
    school: '<div class="achieve-label _school"> <div class="achieve-label__strip"></div> <div class="achieve-label__badge"> <div class="achieve-label__badge-border"> <img src="img/icons/i-ach-lbl-border.svg" alt="" class="svg-pic"> </div> <div class="achieve-label__icon"> <i><img src="img/icons/awards/i-school.svg" alt="" class="svg-pic"></i> </div> </div> </div>',
    chart: '<div class="achieve-label _chart"> <div class="achieve-label__strip"></div> <div class="achieve-label__badge"> <div class="achieve-label__badge-border"> <img src="img/icons/i-ach-lbl-border.svg" alt="" class="svg-pic"> </div> <div class="achieve-label__chart"> <div class="chartbox js-chartbox" data-chart-id="card-chart"> <div class="chart__view"> <div class="chart js-chart map-dot-chart" data-chart-id="card-chart" data-chart-type="donutCustom" data-chart-role="region-chart"></div> </div> <div class="chart__value"> <span class="js-regionobject-chart-value">5</span> </div> </div> </div> </div> </div>'
  },
  objinfo: {
    readydate: '<div class="card-date js-card-readydate"> <p class="card-date__date js-card-readydate__text"></p> <p>Дата готовности</p></div>',
    progress: '<div class="card-progress js-card-progress"> <p class="card-progress__percent js-card-progress__text"></p> <p>Доля фактически построенных школ</p></div>',
    places: '<div class="card-pupils js-card-places"> <p class="card-pupils__count js-card-places__text"></p> <p>Количество дополнительных мест</p></div>',
    count: '<div class="card-pupils js-card-count"> <p class="card-pupils__count js-card-count__text"></p> <p>Мощность</p></div>',
    readiness: '<div class="card-readiness js-card-readiness"><ul class="readiness__list" /><p>Фактическая готовность школ</p></div>'
  },
  readiness: {
    item: '<li class="readiness__item"><div class="readiness-lbl js-card-readiness-label _ready"> <div class="readiness-lbl__count"> <p class="js-card-readiness-count"></p> </div> <div class="readiness-lbl__progress"> <div class="readiness-lbl__percent"> <p class="js-card-readiness-percent-range"></p> </div> </div></div></li>',
    onlyItem: '<li class="readiness__item"><div class="readiness-lbl__count"> <p><span class="js-card-readiness-count"></span><span class="js-card-readiness-unit"></span></p> </div><div class="readiness-lbl js-card-readiness-label _ready _only"> <div class="readiness-lbl__progress"> <div class="readiness-lbl__percent"> <p class="js-card-readiness-percent-range"></p> </div> </div></div></li>'
  }
};

let cardTypes = {
  volume: {
    title: 'Субъект-лидер по объему строительства',
    label: 'build',
    objinfo: 'progress',
    objtitle: 'objectName'
  },
  readiness: {
    title: 'Субъект-лидер по готовности объектов',
    label: 'chart',
    objinfo: 'readiness',
    objtitle: 'objectName'
  },
  extra: {
    title: 'Субъект-лидер по вводу дополнительных мест',
    label: 'place',
    objinfo: 'places',
    objtitle: 'objectName'
  },
  biggest: {
    title: 'Самая большая школа',
    label: 'school',
    objinfo: 'count',
    objtitle: 'objectName'
  },
  lastready: {
    title: 'Последний готовый объект',
    label: 'object',
    objinfo: 'readydate',
    objtitle: 'objectName'
  }
};

let cardIndicators = {
  regionName: 2,
  subjectName: 3,
  objectName: 5,

  count: 13,
  readydate: 14,
  buildFact: 18,
  buildPlan: 17,
  extra: 212,
  readiness: {
    count: 18,
    lvl1: 133,
    lvl2: 132,
    lvl3: 13,
    lvl4: 12,
    lvl5: 11
  }
};

class Card {
  constructor(data) {
    let _this = this;

    _this.data = data;
    // _this.chartData = data.chart.axisY;
    _this.type = data.nominName;
    _this.currentYear = _Objects.Timeline.getValue();

    _this.$el = null;

    _this.init();
  }

  init() {
    let _this = this;

    _this.setMarkdown();
  }

  setMarkdown() {
    let _this = this;
    let tmp = cardTemplate;
    let currCardTypes = cardTypes[_this.type];

    let $cardBox = $(tmp.box);
    let $label = $(tmp.labels[currCardTypes.label]);
    let $objInfo = $(tmp.objinfo[currCardTypes.objinfo]);

    // title
    let $cardTitleText = $cardBox.find('.js-card-title-text');
    $cardTitleText.text(currCardTypes.title);

    // object name
    let $objNameText = $cardBox.find('.js-card-object-text');
    // $objNameText.text(_this.getValueByIndicator(cardIndicators[currCardTypes.objtitle]) || '-');
    $objNameText.text(_this.data.objectMeta.name || '-');

    // label
    let $labelBox = $cardBox.find('.js-card-label');
    $labelBox.append($label);

    // object info
    if (_this.type === 'volume') {
      let $objInfoText = $objInfo.find('.js-card-progress__text');
      $objInfoText.text(_this.getValueByIndicator(cardIndicators['buildFact'])
        / _this.getValueByIndicator(cardIndicators['buildPlan']) * 100 + '%' || '-');
    }
    if (_this.type === 'extra') {
      let $objInfoText = $objInfo.find('.js-card-places__text');
      $objInfoText.text(_this.getValueByIndicator(cardIndicators['extra']) || '-');
    }
    if (_this.type === 'biggest') {
      let $objInfoText = $objInfo.find('.js-card-count__text');
      $objInfoText.text(_this.getValueByIndicator(cardIndicators['count']) || '-');
    }
    if (_this.type === 'lastready') {
      let $objInfoText = $objInfo.find('.js-card-readydate__text');
      $objInfoText.text(formatDate(getDateFromString(_this.getValueByIndicator(cardIndicators['readydate']))) || '-');
      // $objInfoText.text(_this.getValueByIndicator(formatDate(getDateFromString(cardIndicators['readydate']))) || '-');
    }
    if (_this.type === 'readiness') {
      const $chart = $cardBox.find('.js-chart');
      const cardChartName = 'card-chart';
      const readinessColors = ['#8B0000', '#FF582E', '#FFB301', '#3DCC9C', '#009966'];
      $chart.data('colors', readinessColors);
      $chart.data('chart-id', cardChartName).attr('data-chart-id', cardChartName);
      $chart.attr('id', `chart_` + cardChartName);
      const countValue = +_this.getValueByIndicator(cardIndicators['readiness'].count);
      let readinessValues = {
        lvl1: +_this.getValueByIndicator(cardIndicators['readiness'].lvl1),
        lvl2: +_this.getValueByIndicator(cardIndicators['readiness'].lvl2),
        lvl3: +_this.getValueByIndicator(cardIndicators['readiness'].lvl3),
        lvl4: +_this.getValueByIndicator(cardIndicators['readiness'].lvl4),
        lvl5: +_this.getValueByIndicator(cardIndicators['readiness'].lvl5)
      };
      $cardBox.find('.js-regionobject-chart-value').text(countValue);

      const readiness = [
        readinessValues.lvl1,
        readinessValues.lvl2,
        readinessValues.lvl3,
        readinessValues.lvl4,
        readinessValues.lvl5
      ];
      $chart.data('chartData', readiness);
      _Objects.Cards.chartData = readiness;

      readinessValues = [
        {
          objCount: +readinessValues.lvl1,
          readyPercent: '0-30%'
        },
        {
          objCount: readinessValues.lvl2,
          readyPercent: '31-50%'
        },
        {
          objCount: readinessValues.lvl3,
          readyPercent: '51-80%'
        },
        {
          objCount: readinessValues.lvl4,
          readyPercent: '81-100%'
        },
        {
          objCount: readinessValues.lvl5,
          readyPercent: '100%'
        }
      ];

      let $readyList = $objInfo.find('.readiness__list');
      const [nonEmptyElem, ...others] = readinessValues
          .filter(t => t.objCount !== 0)
          .map((t, i) => ({ i, item: t.objCount }));
      if (others.length) {
        readinessValues.forEach((readyItem, i) => {
          if (readyItem.objCount === 0) return true;

          let $item = $(cardTemplate.readiness.item);
          let $itemLabel = $item.find('.js-card-readiness-label');
          let $itemObjCount = $item.find('.js-card-readiness-count');
          let $itemReadyPerc = $item.find('.js-card-readiness-percent-range');

          $itemLabel.data('readiness', i + 1).attr('data-readiness', i + 1);
          $itemObjCount.text(readyItem.objCount);
          $itemReadyPerc.text(readyItem.readyPercent);

          $readyList.prepend($item);
        });
      } else if (nonEmptyElem) {
        const $item = $(cardTemplate.readiness.onlyItem);
        const readyItem = readinessValues[nonEmptyElem.i];
        const $itemLabel = $item.find('.js-card-readiness-label');
        const $itemObjCount = $item.find('.js-card-readiness-count');
        const $itemReadyPerc = $item.find('.js-card-readiness-percent-range');
        const $readyCountUnit = $item.find('.js-card-readiness-unit');

        $itemLabel.data('readiness', nonEmptyElem.i + 1).attr('data-readiness', nonEmptyElem.i + 1);
        $itemObjCount.text(readyItem.objCount);
        $itemReadyPerc.text(readyItem.readyPercent);
        const unitObjects = ['объект', 'объекта', 'объектов'];
        $readyCountUnit.text(' ' + formatNumObj(readyItem.objCount, unitObjects));

        $readyList.prepend($item);
      }
    }

    let $objInfoBox = $cardBox.find('.js-card-objinfo');
    $objInfoBox.append($objInfo);

    // svg icons
    svgInject($cardBox.find('.svg-pic'));

    _this.$el = $cardBox;
    _this.initClicking();
  }

  initClicking() {
    const _this = this;
    const regionMap = _Objects.RegionMap;
    // const mainPage = _Objects.Page;
    const cardType = _this.data.type;
    const currentYear = _Objects.Timeline.getValue() + '';
    const $card = _this.$el;
    const mapData = _Objects.MapData;
    const objectName = _this.data.objectMeta.code;
    const objectParent = _this.data.objectMeta.parent_code;
    const handlerParams = {
      object: {
        regionLevel: 4,
        type: 'object'
      },
      subject: {
        regionLevel: 3,
        type: 'subject'
      }
    };
    if (cardType === 'TYPE_OBJECT') {
      setClickHandler(handlerParams.object);
    } else {
      setClickHandler(handlerParams.subject);
    }

    function setClickHandler({ regionLevel, type }) {
      $card.on('click', function (e) {
        _Objects.Search.hide();
        _Objects.RegionMap.ObjectPage.hide();
        _Objects.RegionMap.isFromSearch = true;
        if (mapData.hasProperty(`${type}sData`)) {
          if (mapData.getElementData(type, objectName) === undefined) {
            mapData.setCardElementData(type, objectName, _this.data);
          }
        } else {
          const currentYearData = mapData.getCurrentYearData();
          currentYearData[`${type}sData`] = {};
          mapData.setCardElementData(type, objectName, _this.data);
        }

        let $currBtn = $(this);
        let pageData = $currBtn.data('page-target');

        let timeout = 0;
        if (_Objects.pageData !== pageData) {
          _Objects.Page.setPage(pageData);
          timeout = 750;
        }

        // Если карта еще грузится, подождать с открытием
        regionMap.dataUpdatingPromise.then(() => {
          if (type === 'object') {
            regionMap.$regions.filter(`[data-region-id="subj-${formatZeroNum(objectParent)}"]`).addClass('_nominated');
            regionMap.setSelectedObject(`obj-${objectName}`);
            setTimeout(() => {
              regionMap.setRightPanel(`obj-${objectName}`);
            }, timeout);
          } else if (type === 'subject') {
            regionMap.setRegionLevel(regionLevel);
            const $currRegion = regionMap.$regions.filter(`[data-region-id="subj-${objectName}"]`).addClass('_nominated');
            regionMap.setSelectedRegion($currRegion, timeout);
          }
        });

      });
    }
  }

  getValueByIndicator(indicator) {
    let _this = this;

    let valObj = _this.data.chart.axisY.filter(({ name }) => name === 'Столбец' + indicator);
    return valObj.length ? valObj[0].value : null;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/cards.js